import { render, staticRenderFns } from "./LinkCard.vue?vue&type=template&id=db0caa32&scoped=true&"
import script from "./LinkCard.vue?vue&type=script&lang=js&"
export * from "./LinkCard.vue?vue&type=script&lang=js&"
import style0 from "./LinkCard.vue?vue&type=style&index=0&id=db0caa32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db0caa32",
  null
  
)

export default component.exports